import { Route } from "react-router-dom";

import DocsLayout from "@/layouts/docs-layout";
import DocsIndexPage from "@/pages/docs/docs-index-page";
import DocsMeetingsPage from "@/pages/docs/docs-meetings-page";
import DocsMeetingsSummaryPage from "@/pages/docs/docs-meetings-summary-page";
import DocsMeetingsDetailedPage from "@/pages/docs/docs-meetings-details-page";
import DocsUsersPage from "@/pages/docs/docs-users-page";
import DocsAudioPage from "@/pages/docs/docs-audio-page";

export function DocsRoutes() {
  return (
    <Route path="/docs" element={<DocsLayout />}>
      <Route index element={<DocsIndexPage />} />
      <Route path="meetings" element={<DocsMeetingsPage />} />
      <Route path="meets-summaries" element={<DocsMeetingsSummaryPage />} />
      <Route path="meets-details" element={<DocsMeetingsDetailedPage />} />
      <Route path="users" element={<DocsUsersPage />} />
      <Route path="audio" element={<DocsAudioPage />} />
    </Route>
  );
}